export interface AdminStat {
  id: string;
  label: string;
  value: string;
  change: string;
  changeType: 'up' | 'down' | 'neutral';
  icon: string;
}

export const adminStats: AdminStat[] = [
  {
    id: 'total-members',
    label: 'Total Members',
    value: '1,284',
    change: '+48 this month',
    changeType: 'up',
    icon: 'ri-group-line',
  },
  {
    id: 'active-subs',
    label: 'Active Subscriptions',
    value: '947',
    change: '+12 this week',
    changeType: 'up',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'open-tickets',
    label: 'Open Tickets',
    value: '23',
    change: '-5 from yesterday',
    changeType: 'down',
    icon: 'ri-customer-service-2-line',
  },
  {
    id: 'revenue',
    label: 'Monthly Revenue',
    value: '$84,920',
    change: '+18.4% vs last month',
    changeType: 'up',
    icon: 'ri-money-dollar-circle-line',
  },
];

export type MemberPlan = 'Starter' | 'Pro' | 'Elite';
export type MemberStatus = 'Active' | 'Inactive' | 'Pending' | 'Suspended';

export interface AdminMember {
  id: string;
  name: string;
  email: string;
  plan: MemberPlan;
  status: MemberStatus;
  joinDate: string;
  lastLogin: string;
  revenue: string;
  state: string;
}

export const adminMembers: AdminMember[] = [
  { id: 'm001', name: 'Marcus Delgado', email: 'marcus.delgado@gmail.com', plan: 'Elite', status: 'Active', joinDate: 'Jan 12, 2024', lastLogin: '2 hours ago', revenue: '$299/mo', state: 'CA' },
  { id: 'm002', name: 'Sandra Whitfield', email: 'swhitfield@promail.com', plan: 'Pro', status: 'Active', joinDate: 'Feb 4, 2024', lastLogin: 'Yesterday', revenue: '$149/mo', state: 'AZ' },
  { id: 'm003', name: 'Kevin Torres', email: 'kevin.torres@outlook.com', plan: 'Starter', status: 'Active', joinDate: 'Mar 1, 2024', lastLogin: '3 days ago', revenue: '$49/mo', state: 'NV' },
  { id: 'm004', name: 'Priya Sharma', email: 'priya.sharma@investco.com', plan: 'Elite', status: 'Active', joinDate: 'Jan 28, 2024', lastLogin: '5 hours ago', revenue: '$299/mo', state: 'CA' },
  { id: 'm005', name: 'Jonathan Kessler', email: 'j.kessler@kcpartners.net', plan: 'Pro', status: 'Inactive', joinDate: 'Nov 15, 2023', lastLogin: '14 days ago', revenue: '$149/mo', state: 'TX' },
  { id: 'm006', name: 'Tanya Morrison', email: 'tanya.morrison@gmail.com', plan: 'Starter', status: 'Pending', joinDate: 'Mar 30, 2026', lastLogin: 'Never', revenue: '$49/mo', state: 'FL' },
  { id: 'm007', name: 'Rafael Ochoa', email: 'rafael.ochoa@realtyfund.io', plan: 'Elite', status: 'Active', joinDate: 'Aug 8, 2023', lastLogin: 'Today', revenue: '$299/mo', state: 'CA' },
  { id: 'm008', name: 'Diane Holloway', email: 'dholloway@propdev.com', plan: 'Pro', status: 'Active', joinDate: 'Sep 22, 2023', lastLogin: '1 day ago', revenue: '$149/mo', state: 'AZ' },
  { id: 'm009', name: 'Tyrese Washington', email: 'tyrese.w@westernhomes.com', plan: 'Elite', status: 'Active', joinDate: 'Oct 3, 2023', lastLogin: '6 hours ago', revenue: '$299/mo', state: 'NV' },
  { id: 'm010', name: 'Cecilia Park', email: 'cpark@sunsetinvest.com', plan: 'Pro', status: 'Suspended', joinDate: 'Jul 19, 2023', lastLogin: '22 days ago', revenue: '$149/mo', state: 'CA' },
  { id: 'm011', name: 'Derek Flemming', email: 'derek.flemming@gmail.com', plan: 'Starter', status: 'Active', joinDate: 'Dec 5, 2023', lastLogin: 'Today', revenue: '$49/mo', state: 'TX' },
  { id: 'm012', name: 'Naomi Vasquez', email: 'naomi.v@capitalfund.net', plan: 'Elite', status: 'Active', joinDate: 'Jun 14, 2023', lastLogin: '3 hours ago', revenue: '$299/mo', state: 'CA' },
  { id: 'm013', name: 'Greg Hoffman', email: 'ghoffman@horizonre.com', plan: 'Pro', status: 'Active', joinDate: 'Feb 27, 2024', lastLogin: 'Yesterday', revenue: '$149/mo', state: 'AZ' },
  { id: 'm014', name: 'Lisa Calloway', email: 'lisa.calloway@gmail.com', plan: 'Starter', status: 'Inactive', joinDate: 'Mar 10, 2024', lastLogin: '8 days ago', revenue: '$49/mo', state: 'NV' },
  { id: 'm015', name: 'Anthony Reeves', email: 'a.reeves@quickflip.io', plan: 'Elite', status: 'Active', joinDate: 'May 2, 2023', lastLogin: 'Today', revenue: '$299/mo', state: 'FL' },
];
